module.exports = __webpack_public_path__ + "static/assets/6f1ecf2a86c80f555e1b8ea23740ec9e.jpg";